import '.d{display:flex;}.ssr-plugin'
import '.aa{align-items:stretch;}.ssr-plugin'
import '.k{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.cq{background:var(--palette-white);}.ssr-plugin'
import '.q{flex-grow:1;}.ssr-plugin'
import '.v{align-items:center;}.ssr-plugin'
import '.b7{max-width:77.5rem;}.ssr-plugin'
import '.cr{justify-content:stretch;}.ssr-plugin'
import '.cs{position:sticky;}.ssr-plugin'
import '.ct{top:0px;}.ssr-plugin'
import '.cu{z-index:10;}.ssr-plugin'
import '.cv{padding-block:1rem;}.ssr-plugin'
import '.cw{height:3rem;}.ssr-plugin'
import '.y{justify-content:space-between;}.ssr-plugin'
import '.c2{flex-wrap:wrap;}.ssr-plugin'
import '.cx{margin-bottom:0px;}.ssr-plugin'
import '.cy{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.b6{margin-top:2rem;}.ssr-plugin'
import '.cz{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { getTitleLevelStyle } from '@app/components/core/typography/styles'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'
import { PageSeo } from '@app/components/core/seo/PageSeo'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <>
      <PageSeo pageTitle={title} noindex />
      <ClientOnly>
      <div className="d aa k e cq"
      >
        <div className="q d v k e"
        >
          <div className="b7 d e cr cs ct cu cq"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="cv cw d y v c2"
            >
              <styled.span className="cx"
                style={{
                  ...getTitleLevelStyle(5, isMobile),}}
              >
                {title}
              </styled.span>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="cy d e aa b6 cz b7"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
      </ClientOnly>
    </>
  )
}
